export default __webpack_public_path__ + "static/website-8892f5d37e6b1d782a84b36743471927.png";